import React from 'react';
import styled from 'styled-components';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';
import { IoMdAlert } from 'react-icons/io';

// TODO: remove styled components from this file once these classes are moved out...KA
const Container = styled.div`
  .sso-button-area {
    flex-direction: column;

    button {
      margin-bottom: 0;
    }

    a {
      display: block;
    }

    @media screen and (min-width: 768px) {
      flex-direction: row;
    }
  }

  .sso-invalid-field {
    input,
    input:focus {
      border-color: #cc4749;
    }
  }
`;

const cssClasses = {
  default: 'bg-[#f7f7f7]',
  error: 'bg-[#ffdddd]',
  info: 'bg-[#e0edfc]',
  notify: 'bg-[#feebcb]',
  success: 'bg-[#d5ffd8]',
};

const iconColorMap = {
  error: 'fill-destructive',
  info: 'fill-primary',
  notify: 'fill-primary',
  success: 'fill-green',
};

export type MessageBoxTypes =
  | 'default'
  | 'error'
  | 'info'
  | 'notify'
  | 'success';

interface MessageBoxProps {
  messageList: { error: string }[] | string[];
  type?: MessageBoxTypes;
}

const MessageBox = ({ messageList, type = 'default' }: MessageBoxProps) => {
  const { tt } = useUiComponentsInternationalContext();

  if (messageList?.length > 0)
    return (
      <Container>
        <div
          className={`flex gap-2 items-center p-4 w-auto mb-4 text-base text-black rounded-sm ${cssClasses[type]}`}
        >
          {type !== 'default' && (
            <IoMdAlert className={`${iconColorMap[type]} size-6`} />
          )}
          <ul className="m-0 p-0 list-none">
            {messageList.map(error => (
              <li
                className="mb-4 p-0 list-none last:mb-0"
                key={error?.error || error}
              >
                {error ===
                "Failed to read the 'localStorage' property from 'Window': Access is denied for this document."
                  ? tt(
                      s =>
                        s.formMessageBoxComponent.enableCookiesForLoginMessage
                    )
                  : error?.error || error}
              </li>
            ))}
          </ul>
        </div>
      </Container>
    );

  return null;
};

export default MessageBox;
